import { useState } from 'react';
import { ListItemText, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import { Link } from 'react-router-dom';
import { AdminWorkspaceState, useAdminWorkspace } from 'src/workspaces/AdminWorkspaceProvider';

export const messageDestinations = (state: AdminWorkspaceState) => {
  if (state.kind === 'platform') return [
    { label: 'Company Conversations', to: '/platform/companies', detail: 'Choose a company workspace.' },
    { label: 'Support Tickets', to: '/platform/support-tickets', detail: 'Open platform support categories.' }
  ];
  if (state.kind === 'legacy' || (state.kind === 'company' && state.status === 'ready')) return [
    { label: 'Company Conversations', to: '/dashboards/messenger', detail: 'Open conversations available to your account.' }
  ];
  return [];
};

export default function HeaderMessages() {
  const state = useAdminWorkspace();
  const links = messageDestinations(state);
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  if (!links.length) return null;
  return <>
    <Tooltip title="Messages" arrow>
      <button type="button" aria-label="Messages"
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
        onClick={event => setAnchor(event.currentTarget)}
        className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.03] text-white/[0.72] transition-all duration-200 hover:bg-white/[0.08] hover:text-white">
        <ChatBubbleOutlineRoundedIcon />
      </button>
    </Tooltip>
    <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
      {links.map(link => <MenuItem key={link.to} component={Link} to={link.to} onClick={() => setAnchor(null)}>
        <ListItemText primary={link.label} secondary={link.detail} />
      </MenuItem>)}
      {state.kind === 'company' && <Typography variant="caption" component="li" sx={{ px: 2, py: 1, maxWidth: 300, listStyle: 'none' }}>
        Platform support tickets require Global Console access.
      </Typography>}
    </Menu>
  </>;
}
